export const SET_TOAST = "SET_TOAST";
export const POST_TOAST = "POST_TOAST";
export const CLEAR_TOAST = "CLEAR_TOAST";